


// import React, { Suspense, lazy, useEffect } from "react";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import "./assets/css/style.css";
// import Navbar1 from "./components/partials/Navbar1";
// import Footer1 from "./components/Footer1";
// // import GoogleAnalytics from "./GoogleAnalytics";

// import EatingHouse from "./components/services/eating_house/ServicesPage";
// import ServicesPage from "./components/services/services/ServicesPage";
// import { Helmet } from "react-helmet-async";

// // import TradeLicense from "./components/services/trade-license/TradeLicense";
// import CompanyRegistration from "./components/services/company-registration/CompanyRegistration";
// import ISOCertificationRegistration from "./components/services/ISOCertification/ISOCertificationRegistration";
// import AnnualComplianceRegistration from "./components/services/AnnualCompliance/AnnualComplianceRegistration";
// import {  loadGA } from "./utils/analytics";

// const TradeLicense = lazy(() =>
//   import("./components/services/trade-license/TradeLicense")
// );
// const Home = lazy(() => import("./components/Home"));
// const AboutUs = lazy(() => import("./components/AboutUs"));
// const ContactUs = lazy(() => import("./components/ContactUs"));
// const AllClientPage = lazy(() => import("./components/AllClientPage"));
// // const AllServicesPage = lazy(() => import("./components/AllServicesPage"));
// const FssaiLicense = lazy(() => import("./components/services/fssai/FssaiLicense"));

// const DpccLicense = lazy(() => import("./components/services/dpcc/DpccLicense"));
// const McdLicense = lazy(() => import("./components/services/mcd/McdLicense"));
// const ExportDefault = lazy(() => import("./components/services/exportDefault/ExportDefault"));
// const DdaLicense = lazy(() => import("./components/services/dda_oroperty/DdaLicense"));
// // const GemRegistration = lazy(() => import("./components/services/gem_reg/GemRegistration"));
// const MsmeReg = lazy(() => import("./components/services/msme/MsmeReg"));
// const ExciseReg = lazy(() => import("./components/services/excise/ExciseReg"));
// const FireNocReg = lazy(() => import("./components/services/fireNoc/FireNocReg"));
// const GstLicense = lazy(() => import("./components/services/gst/GstLicense"));

// const PartnerServices = lazy(() => import("./components/PartnerServices"));
// // const BlogPage = lazy(() => import("./components/services/blog/BlogPage"));
// // const DetailedBlogPage = lazy(() => import("./components/services/blog/DetailedBlogPage"));
// const LoginPage = lazy(() => import("./components/LoginPage"));
// const ForgetPassword = lazy(() => import("./components/ForgetPassword"));
// const ForgetPassword1 = lazy(() => import("./components/ForgetPassword1"));
// const ForgetPassword2 = lazy(() => import("./components/ForgetPassword2"));
// const Confirm = lazy(() => import("./components/Confirm"));
// const ErrorPage = lazy(() => import("./components/Error"));

// // Admin Lazy Loading
// const AdminHome = lazy(() => import("./components/Admin/AdminHome"));
// const AdminLicense = lazy(() => import("./components/Admin/Licenses/AdminLicense"));
// const AdminCreateLicense = lazy(() => import("./components/Admin/Licenses/AdminCreateLicense "));
// const AdminProfileUpdate = lazy(() => import("./components/Admin/AdminProfileUpdate"));
// const AdminUpdateLicense = lazy(() => import("./components/Admin/Licenses/AdminUpdateLicense"));
// const AdminCreateClient = lazy(() => import("./components/Admin/Clients/AdminCreateClient"));
// const AdminClient = lazy(() => import("./components/Admin/Clients/AdminClient"));
// const AdminUpdateClient = lazy(() => import("./components/Admin/Clients/AdminUpdateClient"));
// const AdminCreateTestimonial = lazy(() => import("./components/Admin/Testimonial/AdminCreateTestimonial"));
// const AdminTestimonial = lazy(() => import("./components/Admin/Testimonial/AdminTestimonial"));
// const AdminAllQuery = lazy(() => import("./components/Admin/Query/AdminAllQuery"));
// const AdminWebQuery = lazy(() => import("./components/Admin/WebQuery/AdminWebQuery"));
// const AdminCreateProfile = lazy(() => import("./components/Admin/AdminCreateProfile"));
// const AdminAllUsers = lazy(() => import("./components/Admin/User/AdminAllUsers"));

// export default function App() {
//   const isAdmin = localStorage.getItem("login") && localStorage.getItem("role") === "Admin";
//   useEffect(() => {
//     loadGA();
//   }, []);
//   return (
//     <BrowserRouter>
//       <Navbar1 />

//       <Helmet>
//         <title>Business Licensing & Compliance Consultants in India | Perfect Global Consultancy</title>
//         <meta
//           name="description"
//           content="Perfect Global Consultancy provides business licensing, registrations, and compliance services across India including GST, FSSAI, Trade License, and more."
//         />
//       </Helmet>

//       {/* <GoogleAnalytics /> */}

//       <Suspense fallback={<div style={{ padding: 50 }}>Loading...</div>}>

//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/about-us" element={<AboutUs />} />
//           <Route path="/contact-us" element={<ContactUs />} />
//           <Route path="/clients" element={<AllClientPage />} />



//           {/* <Route path="/allservices-page" element={<AllServicesPage />} /> */}
//           {/* <Route path="/portfolio" element={<PortfolioPage />} /> */}
//           {/* <Route path="/blog" element={<BlogPage />} /> */}
//           {/* <Route path="/blog/:slug/:id" element={<DetailedBlogPage />} /> */}



//           {/* All services */}

//           {/* ------------------------------------------------------------ */}

          
//           <Route path="/annual-compliance" element={<AnnualComplianceRegistration />} />
//           <Route path="/iso-certification" element={<ISOCertificationRegistration />} />
//           <Route path="/company-registration" element={<CompanyRegistration />} />
//           <Route path="/trade-license" element={<TradeLicense />} />
//           <Route path="/fssai-license" element={<FssaiLicense />} />
//           <Route path="/dda-property" element={<DdaLicense />} />
//           <Route path="/dpcc-license" element={<DpccLicense />} />
//           <Route path="/fire-noc-license" element={<FireNocReg />} />
//           <Route path="/msme-udyam-registration" element={<MsmeReg />} />
//           <Route path="/gst-registration" element={<GstLicense />} />
//           <Route path="/eating-house-license" element={<EatingHouse />} />
//           <Route path="/health-trade-license" element={<McdLicense />} />
//           <Route path="/trademark-registration" element={<ExciseReg />} />
//           <Route path="/import-export-services" element={<ExportDefault />} />
//           <Route path="/admin/create/profile" element={<AdminCreateProfile />} />
          

//           {/* Web + Marketing */}
//           <Route path="/services" element={<ServicesPage />} />
        
//           <Route path="/amazon-flipkart-partner-service" element={<PartnerServices />} />

//           {/* Login & Password */}
//           <Route path="/login" element={<LoginPage />} />
//           <Route path="/forget-password" element={<ForgetPassword />} />
//           <Route path="/forget-password1" element={<ForgetPassword1 />} />
//           <Route path="/forget-password2" element={<ForgetPassword2 />} />
//           <Route path="/confirm" element={<Confirm />} />

//           {/* Admin Routes */}
//           {isAdmin && (
//             <>
//               <Route path="/admin" element={<AdminHome />} />
//               <Route path="/admin/license" element={<AdminLicense />} />
//               <Route path="/admin/license/create" element={<AdminCreateLicense />} />
//               <Route path="/admin/profile/update" element={<AdminProfileUpdate />} />
//               <Route path="/admin/license/update/:_id" element={<AdminUpdateLicense />} />
//               <Route path="/admin/client" element={<AdminClient />} />
//               <Route path="/admin/client/create" element={<AdminCreateClient />} />
//               <Route path="/admin/client/update/:_id" element={<AdminUpdateClient />} />
//               <Route path="/admin/testimonial" element={<AdminTestimonial />} />
//               <Route path="/admin/testimonial/create" element={<AdminCreateTestimonial />} />
//               <Route path="/admin/allquery" element={<AdminAllQuery />} />
//               <Route path="/admin/webquery" element={<AdminWebQuery />} />
//               <Route path="/admin/user" element={<AdminAllUsers />} />
//             </>
//           )}

//           {/* Fallback */}
//           <Route path="/*" element={<ErrorPage />} />
//         </Routes>

//       </Suspense>

//       <Footer1 />
//     </BrowserRouter>
//   );
// }








import React, { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./assets/css/style.css";
import { Helmet } from "react-helmet-async";
// import { loadGA } from "./utils/analytics";

// Lazy-loaded components
const Navbar1 = lazy(() => import("./components/partials/Navbar1"));
const Footer1 = lazy(() => import("./components/Footer1"));

// Pages
const Home = lazy(() => import("./components/Home"));
const AboutUs = lazy(() => import("./components/AboutUs"));
const ContactUs = lazy(() => import("./components/ContactUs"));
const AllClientPage = lazy(() => import("./components/AllClientPage"));
const ServicesPage = lazy(() => import("./components/services/services/ServicesPage"));

// Service Pages
const EatingHouse = lazy(() => import("./components/services/eating_house/ServicesPage"));
const CompanyRegistration = lazy(() => import("./components/services/company-registration/CompanyRegistration"));
const ISOCertificationRegistration = lazy(() => import("./components/services/ISOCertification/ISOCertificationRegistration"));
// const AnnualComplianceRegistration = lazy(() => import("./components/services/AnnualCompliance/AnnualComplianceRegistration"));
const TradeLicense = lazy(() => import("./components/services/trade-license/TradeLicense"));
const FssaiLicense = lazy(() => import("./components/services/fssai/FssaiLicense"));
// const DpccLicense = lazy(() => import("./components/services/dpcc/DpccLicense"));
const McdLicense = lazy(() => import("./components/services/mcd/McdLicense"));
const ExportDefault = lazy(() => import("./components/services/exportDefault/ExportDefault"));
// const DdaLicense = lazy(() => import("./components/services/dda_oroperty/DdaLicense"));
const MsmeReg = lazy(() => import("./components/services/msme/MsmeReg"));
const ExciseReg = lazy(() => import("./components/services/excise/ExciseReg"));
// const FireNocReg = lazy(() => import("./components/services/fireNoc/FireNocReg"));
const GstLicense = lazy(() => import("./components/services/gst/GstLicense"));
// const PartnerServices = lazy(() => import("./components/PartnerServices"));

// Auth
const LoginPage = lazy(() => import("./components/LoginPage"));
const ForgetPassword = lazy(() => import("./components/ForgetPassword"));
const ForgetPassword1 = lazy(() => import("./components/ForgetPassword1"));
const ForgetPassword2 = lazy(() => import("./components/ForgetPassword2"));
const Confirm = lazy(() => import("./components/Confirm"));

// Error
const ErrorPage = lazy(() => import("./components/Error"));

// Admin routes lazy load
// const AdminRoutes = lazy(() => import("./routes/AdminRoutes"));

// Loader Component
const Loader = () => (
  <div style={{ padding: 50, textAlign: "center" }}>Loading...</div>
);

export default function App() {
  const [isAdmin, setIsAdmin] = useState(false);

  // useEffect(() => {
  //   loadGA();
  //   const login = localStorage.getItem("login");
  //   const role = localStorage.getItem("role");
  //   setIsAdmin(login && role === "Admin");
  // }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Navbar1 />

        <Helmet>
          <title>
            Business Licensing & Compliance Consultants in India | Perfect Global Consultancy
          </title>
          <meta
            name="description"
            content="Perfect Global Consultancy provides business licensing, registrations, and compliance services across India including GST, FSSAI, Trade License, and more."
          />
        </Helmet>

        <Routes>
          {/* Public Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/clients" element={<AllClientPage />} />
          <Route path="/services" element={<ServicesPage />} />
          {/* <Route path="/amazon-flipkart-partner-service" element={<PartnerServices />} /> */}

          {/* Service Routes */}
          {/* <Route path="/annual-compliance" element={<AnnualComplianceRegistration />} /> */}
          <Route path="/iso-certification" element={<ISOCertificationRegistration />} />
          <Route path="/company-registration" element={<CompanyRegistration />} />
          <Route path="/trade-license" element={<TradeLicense />} />
          <Route path="/fssai-license" element={<FssaiLicense />} />
          {/* <Route path="/dda-property" element={<DdaLicense />} /> */}
          {/* <Route path="/dpcc-license" element={<DpccLicense />} /> */}
          {/* <Route path="/fire-noc-license" element={<FireNocReg />} /> */}
          <Route path="/msme-udyam-registration" element={<MsmeReg />} />
          <Route path="/gst-registration" element={<GstLicense />} />
          <Route path="/eating-house-license" element={<EatingHouse />} />
          <Route path="/health-trade-license" element={<McdLicense />} />
          <Route path="/trademark-registration" element={<ExciseReg />} />
          <Route path="/import-export-services" element={<ExportDefault />} />

          {/* Auth Pages */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/forget-password1" element={<ForgetPassword1 />} />
          <Route path="/forget-password2" element={<ForgetPassword2 />} />
          <Route path="/confirm" element={<Confirm />} />

          {/* Admin Routes */}
          {/* {isAdmin && <Route path="/admin/*" element={<AdminRoutes />} />} */}

          {/* Fallback */}
          <Route path="/*" element={<ErrorPage />} />
        </Routes>

        <Footer1 />
      </Suspense>
    </BrowserRouter>
  );
}
